const button = document.querySelector('.search__button--mobile');
const search = document.querySelector('.header__search.header__search--mobile');
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
const headerBounds = {};
const siteHeader = document.querySelector('.section-header');
let currentScrollTop = 0;

let observer = new IntersectionObserver((entries, observer) => {
  headerBounds = entries[0].intersectionRect;
  observer.disconnect();
});

observer.observe(siteHeader);

window.addEventListener('scroll', function() {
    currentScrollTop = scrollTop;

    if (scrollTop > currentScrollTop && scrollTop > headerBounds.bottom) {
        console.log('hit');
    }
});

button.addEventListener('click', function() {
    button.classList.toggle('open');
    button.classList.toggle('closed');
    search.classList.toggle('open');
    search.classList.toggle('closed');
});
